var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_751_658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0.883942H5C4.4 0.883942 4 1.29466 4 1.91073V4.99108H1C0.4 4.99108 0 5.4018 0 6.01787V27.5804C0 28.1964 0.4 28.6072 1 28.6072H22C22.6 28.6072 23 28.1964 23 27.5804V24.5H26C26.6 24.5 27 24.0893 27 23.4732V1.91073C27 1.29466 26.6 0.883942 26 0.883942ZM21 26.5536H2V7.04466H21V26.5536ZM25 22.4464H23V6.01787C23 5.4018 22.6 4.99108 22 4.99108H6V2.93751H25V22.4464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.2857H12V12.1786C12 11.5625 11.6 11.1518 11 11.1518C10.4 11.1518 10 11.5625 10 12.1786V16.2857H6C5.4 16.2857 5 16.6964 5 17.3125C5 17.9286 5.4 18.3393 6 18.3393H10V22.4464C10 23.0625 10.4 23.4732 11 23.4732C11.6 23.4732 12 23.0625 12 22.4464V18.3393H16C16.6 18.3393 17 17.9286 17 17.3125C17 16.6964 16.6 16.2857 16 16.2857Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_751_658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27.7232,
    fill: "white",
    transform: "translate(0 0.883942)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.5f15e6b81468615fc5cd626ed38ef4c4.svg";
export { ForwardRef as ReactComponent };